import MSAuth from '@/utilis/ms-auth'

const authService = new MSAuth(
  process.env.API_URL + 'auth/token',
  process.env.API_URL + 'auth/refresh',
  { name: 'dashboard' }
)

export default authService



// WEBPACK FOOTER //
// ./src/services/auth.service.js